import "@hotwired/turbo-rails"
import "channels";
import "controllers"
import "bootstrap";
import TurbolinksAdapter from 'vue-turbolinks';
import Vue from 'vue/dist/vue.esm';
import VCalendar from 'v-calendar';
import axios from 'axios';
import Select from 'components/select';
import TimeSelect from 'components/time_select';
import Notifications from 'vue-notification';
import add from 'date-fns/add'
import { getTimezoneOffset, format } from 'date-fns-tz';
import Vuelidate from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';

document.addEventListener('turbo:load', () => {
  Vue.use(TurbolinksAdapter);
  Vue.use(Vuelidate);
  Vue.use(VCalendar, {});
  Vue.use(Notifications);
  const app = new Vue({
    el: '#app',
    data() {
      return {
        available: new URL(location.href).searchParams.get('available') || true,
        date: null,
        minDate: null,
        fee: null,
        discount: null,
        total: null,
        hotel: new URL(location.href).searchParams.get('hotel') || null,
        hotelLogo: null,
        roomCategory: null,
        roomCategories: null,
        time: null,
        times: null,
        timeBlock: null,
        timeBlocks: null,
        roomCategoryPhoto: null,
        rut: new URL(location.href).searchParams.get('rut') || null,
        name: new URL(location.href).searchParams.get('name') || null,
        email: new URL(location.href).searchParams.get('email') || null,
        mobile: null,
        submitStatus: null,
        add,
        getTimezoneOffset,
        format
      }
    },
    computed: {
      // time: function() {
      //   return this.date != null ? this.date.setHours(this.sel_time) : null;
      // },
      dateToTime() {
        let date = this.date;
        date.setHours(this.time);
        return date.getTime() / 1000;
      },
      year: function () {
        return this.date != null ? this.date.getFullYear() : null;
      },
      month: function () {
        return this.date != null ? this.date.getMonth() : null;
      },
      day: function () {
        return this.date != null ? this.date.getDate() : null;
      }
    },
    components: {
      "VueSelect": Select,
      "VueTimeSelect": TimeSelect
    },
    methods: {
      getTimeBlocks() {
        axios
          .get('/api/time_blocks')
          .then(response => {
            this.timeBlocks = response.data
            if (this.timeBlock == null) {
              this.timeBlock = this.timeBlocks[0].id.toString();
            }
          })
      },
      getCategories() {
        axios
          .get('/api/room_categories/hotel/' + this.hotel)
          .then(response => (this.roomCategories = response.data))
      },
      getFee() {
        if (this.roomCategory != "") {
          axios
            .get(`/api/fees/date/${this.dateToTime}/room_category/${this.roomCategory}/time_block/${this.timeBlock}`)
            .then(response => {
              this.fee = response.data.amount;
              this.discount = response.data.discount
              this.total = response.data.total
            })
        }
      },
      update(hotel) {
        this.hotel = hotel;
      },
      submit: function (e) {
        e.preventDefault();
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.submitStatus = 'ERROR';
        } else {
          this.$refs.form.submit()
        }
      },
      formatRUT() {
        let rut = this.rut.replace('-', '').replace(/\./g, '');
        let dv = rut.slice(-1).toUpperCase();
        let cuerpo = rut.slice(0, -1);
        cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.rut = cuerpo + '-' + dv;
      },
      setTimeBlocks() {
        if (this.timeBlocks != null) {
          let timeBlock = this.timeBlocks.find(timeBlock => timeBlock.id == this.timeBlock);
          let first_entry;
          let last_entry;
          let first = true;
          this.times = [];
          if (timeBlock.first_entry != null) {
            first_entry = timeBlock.first_entry;
            last_entry = timeBlock.last_entry;
          } else {
            first_entry = 0;
            last_entry = 22;
          }
          for (let i = first_entry; i <= last_entry; i++) {
            let date = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), i);
            // 
            if ((date - this.minDate) / 3600000 >= 0) {
              if (first) {
                first = false;
                this.time = i.toString();
              }
              if (i < 10) {
                this.times.push({ name: "0" + i + ":00", value: i });
              } else {
                this.times.push({ name: i + ":00", value: i });
              }
            }
          }
        }
      }
    },
    validations: {
      hotel: {
        required
      },
      roomCategory: {
        required
      },
      date: {
        required
      },
      time: {
        required
      },
      name: {
        required,
        minLength: minLength(3)
      },
      rut: {
        required,
        isRUTValid
      },
      email: {
        required,
        email
      },
      mobile: {
        required,
        minLength: minLength(9)
      },
      fee: {
        required
      }
    },
    watch: {
      roomCategory: function () {
        this.getFee();
        let roomCategories = this.roomCategories
        for (let i = 0; i < roomCategories.length; i++) {
          if (roomCategories[i].id == this.roomCategory) {
            this.roomCategoryPhoto = roomCategories[i].main_photo
          }
        }
      },
      timeBlock: function () {
        this.getFee();
        this.setTimeBlocks();
      },
      date: function () {
        this.setTimeBlocks();
        this.getFee();
      },
      time: function () {
        this.getFee();
      }
    },
    mounted() {
      let element = document.getElementById("vue-data");
      this.hotel = element.dataset.hotel;
      this.getCategories();
      this.getTimeBlocks();
      if (new URL(location.href).searchParams.get('time')) {
        this.date = new Date(parseInt(new URL(location.href).searchParams.get('time')))
      } else {
        // Time comes from the server
        this.date = new Date(parseInt(element.dataset.time));
        // 60000 to convert from ms to minutes
        // Add timezones offsets to convert to America/Santiago timezone
        let zoneOffset = this.date.getTimezoneOffset() + (getTimezoneOffset('America/Santiago') / 60000);
        this.date = add(this.date, { minutes: zoneOffset });
        this.date.setMinutes(0, 0, 0);
        this.date.setHours(this.date.getHours());
        this.date.setHours(this.date.getHours() + 4);
        this.minDate = new Date(this.date.toISOString());
      }
      let availableParam = new URL(location.href).searchParams.get('available');
      if (availableParam && availableParam == 'false') {
        this.$notify({
          duration: 5000,
          type: 'error',
          text: 'Lo sentimos, no hay habitaciones disponibles con las opciones seleccionadas'
        });
      }
    }
  });
})

function formatMoney(number, decPlaces, decSep, thouSep) {
  decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
    decSep = typeof decSep === "undefined" ? "." : decSep;
  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  var sign = number < 0 ? "-" : "";
  var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return sign +
    (j ? i.substr(0, j) + thouSep : "") +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
    (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
}

const isRUTValid = (rut) => {
  if (rut == null || rut.length < 8) { return false; }
  let valor = rut.replace(/\./g, '');
  valor = valor.replace(/\-/g, '');
  let cuerpo = valor.slice(0, -1);
  let dv = valor.slice(-1).toUpperCase();
  if (cuerpo.length < 7) { return false; }
  let suma = 0;
  let multiplo = 2;
  for (let i = 1; i <= cuerpo.length; i++) {
    let index = multiplo * valor.charAt(cuerpo.length - i);
    suma = suma + index;
    if (multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
  }
  let dvEsperado = 11 - (suma % 11);
  dv = (dv == 'K') ? 10 : dv;
  dv = (dv == 0) ? 11 : dv;
  if (dvEsperado != dv) { return false; }
  return true;
};